import { connect } from "react-redux";
import DealerFinance from "./DealerFinance";
import { bindActionCreators } from "redux";
import {walletApprovalFinance} from "../../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    listing : state.Wallet.dealerPaymentRequestApproval,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletApprovalFinance
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DealerFinance);